import Vue from 'vue'

let modal = new Vue({
  data () {
    return {
      element: null,
      isModalVisible: false,
      methodToRun: null,
      modalBody: null,
      updatedData: ''
    }
  },

  methods: {
    closeModal () {
      this.isModalVisible = false
    },

    showModal (modalBody, element = null) {
      this.element = element
      this.modalBody = modalBody
      this.isModalVisible = true
      console.log(this.element)
    },

    updateData (methodToRun = null) {
      this.methodToRun = methodToRun
      this.updatedData = Date.now()
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$modal = modal
  }
}
